module.exports = __webpack_public_path__ + "img/text08.09679da4.svg";